import React from "react";

export default function TradeTimeline({ events = [] }) {
  return (
    <ol className="space-y-6">
      {events.map((event, index) => {
        const isLast = index === events.length - 1;
        return (
          <li key={event.title} className="grid grid-cols-[auto_1fr] gap-x-4">
            <div className="flex flex-col items-center">
              <span
                className={[
                  "mt-1 h-2.5 w-2.5 shrink-0 rounded-full",
                  event.active
                    ? "bg-hint-strong shadow-[0_0_12px_rgba(45,226,232,0.55)]"
                    : "bg-white ring-2 ring-ink/15",
                ].join(" ")}
              />
              {isLast ? null : <span className="mt-1 w-px flex-1 bg-ink/10" />}
            </div>
            <div className={isLast ? "" : "pb-1"}>
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                <span className="text-sm font-medium text-muted">{event.time}</span>
                <h3 className="text-base font-semibold text-ink">{event.title}</h3>
              </div>
              <p className="mt-1 max-w-md text-sm leading-relaxed text-muted">{event.body}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
